module.exports = __webpack_public_path__ + "static/media/imgStrategy.31a0e707.svg";